import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeepDiveNewComponent } from './deep-dive-new.component';

const routes: Routes = [
  {
    path: '',
    component: DeepDiveNewComponent
  },
  {
    path: ':id',
    component: DeepDiveNewComponent
  },
];
 

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeepDiveNewRoutingModule { }
